import { useState } from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import KpiDriverHeader from "./KpiDriverHeader";
import KpiDriverTabs from "./KpiDriverTabs";

interface Source {
  title: string;
  url: string;
}

export interface KpiDriver {
  title: string;
  score: number;
  reasoning: string;
  metadata?: { kpi_model_node_id?: number };
  sources?: Source[];
}

interface KpiDriverCardProps {
  driver: KpiDriver;
  defaultOpen?: boolean;
  heatmapSubcategoryLabel?: string;
}

export default function KpiDriverCard({
  driver,
  defaultOpen = false,
  heatmapSubcategoryLabel,
}: KpiDriverCardProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen}>
      <Card className="gap-0 py-0">
        <CollapsibleTrigger className="w-full">
          <CardHeader className="p-0">
            <KpiDriverHeader
              title={driver.title}
              score={driver.score}
              isOpen={isOpen}
              heatmapSubcategoryLabel={heatmapSubcategoryLabel}
            />
          </CardHeader>
        </CollapsibleTrigger>

        <CollapsibleContent>
          <CardContent className="border-t border-border p-0">
            <KpiDriverTabs
              reasoning={driver.reasoning}
              sources={driver.sources}
            />
          </CardContent>
        </CollapsibleContent>
      </Card>
    </Collapsible>
  );
}
